// country.code.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of } from 'rxjs';

export type CountryCode = { label: string; value: string };

@Injectable({ providedIn: 'root' })
export class CountryCodeService {
    private readonly assetUrl = 'assets/country-codes.json';

    constructor(private http: HttpClient) {}

    getCountryCodes() {
        return this.http.get<CountryCode[] | any>(this.assetUrl).pipe(
            map((data) => this.normalize(data)),
            catchError((err) => {
                console.warn('Country codes: usando fallback por error/404 en assets', err);
                return of(this.fallback());
            })
        );
    }

    private normalize(data: any): CountryCode[] {
        // Asegura que siempre sea: [{label, value}]
        if (Array.isArray(data) && data.length && 'label' in data[0] && 'value' in data[0]) {
            return data as CountryCode[];
        }
        if (Array.isArray(data)) {
            // transforma [{name, dial_code}] u otros formatos comunes
            return data.map((x: any) => ({
                label: x.label ?? `${x.name ?? x.country ?? ''} (${x.dial_code ?? x.code ?? ''})`,
                value: x.value ?? x.dial_code ?? x.code ?? ''
            }));
        }
        return this.fallback();
    }

    private fallback(): CountryCode[] {
        return [
            { label: 'Bolivia (+591)', value: '+591' }, // por defecto
            { label: 'Argentina (+54)', value: '+54' },
            { label: 'Chile (+56)', value: '+56' },
            { label: 'Colombia (+57)', value: '+57' },
            { label: 'Perú (+51)', value: '+51' },
            { label: 'México (+52)', value: '+52' },
            { label: 'Estados Unidos (+1)', value: '+1' },
        ];
    }
}
